import { css, StyleSheet } from 'aphrodite'
import React from 'react'
import { useState } from 'react'
import PropTypes from 'prop-types'
import { COLOR_GRAY__300, COLOR_GRAY__500 } from '../../lib/colors'
import IconFile from '../Icon/IconFileText'
import UIButton from './UIButton'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

const UIFileUpload = React.forwardRef(function UIFileUpload(
  { documentTitle, dynamicStyle, onChange, onClick, fileType, accept },
  ref
) {
  const [file, setFile] = useState(null)
  const { t } = useTranslation('fileUpload')
  const [buttonMessageFile, setButtonMessageFile] = useState(t('chooseFile'))

  const handleChange = (event) => {
    if (fileType && event.target.files[0].type.includes(fileType)) {
      setFile(event.target.files[0])
      onChange(event.target.files[0])
      setButtonMessageFile(t('changeFile'))
    } else if (!fileType) {
      setFile(event.target.files[0])
      onChange(event.target.files[0])
      setButtonMessageFile(t('chooseFile'))
    } else {
      setFile(null)
      toast.error(t('errorFormat'))
      setButtonMessageFile(t('chooseFile'))
    }
  }

  return (
    <div className={css(styles.container, dynamicStyle)}>
      <IconFile dynamicStyle={styles.iconSize} />
      <p className={css(styles.documentText)}>
        {file !== null ? file.name : documentTitle}
      </p>
      <div className={css(styles.containerBtn)}>
        <UIButton
          label={buttonMessageFile}
          design="secondary"
          smaller
          onClick={onClick}
        />
        <input
          type="file"
          className={css(styles.inputFile)}
          ref={ref}
          onChange={handleChange}
          accept={accept}
        />
      </div>
    </div>
  )
})

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 315,
    height: 150,
    borderWidth: 2,
    borderRadius: 5,
    borderStyle: 'dashed',
    borderColor: COLOR_GRAY__300,
  },
  documentText: {
    fontWeight: 400,
    fontSize: 10,
    textAlign: 'center',
    color: COLOR_GRAY__500,
  },
  containerBtn: {
    width: 181,
  },
  inputFile: {
    display: 'none',
  },
  iconSize: {
    width: 30,
    height: 30,
  },
})

UIFileUpload.propTypes = {
  documentTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  dynamicStyle: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  fileType: PropTypes.string,
  accept: PropTypes.string,
}

export default UIFileUpload
